import { render, staticRenderFns } from "./FiveYearByType.vue?vue&type=template&id=ab730528&scoped=true&"
import script from "./FiveYearByType.vue?vue&type=script&lang=js&"
export * from "./FiveYearByType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab730528",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
